import './App.css';

function App() {
  return (
    <div style={{padding: 16}}>
      <h1>BMI Calculator</h1>
      <a href="https://play.google.com/store/apps/details?id=com.mohitatray.bmicalculator">Android App</a>
      <br/><a href="./privacypolicy.html">Privacy Policy</a>
    </div>
  );
}

export default App;
